import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Container, Grid } from '@mui/material';
import EirOfferCardContainer from '../eir-offer-card/EirOfferCardContainer';
import MobileOfferToggle from '../eir-mobile-offer-toggle/MobileOfferToggle';
import styles from '../eir-mobile-offer-toggle/styles';
import EirInformation from '../eir-information/EirInformation';
import { MobileOfferContext } from './mobile.context';
import KeepMyNumberToggle from '../eir-keep-my-number-toggle/KeepMyNumberToggle';
import MobileContentCarousel from './MobileContentCarousel';
// import MobileSecondaryBannerCurve from './MobileSecondaryBannerCurve';
import { getCookie } from '../../hooks/useCookie';
import { getLocalStorage } from '../../hooks/useLocalStorage';
import { formatAfterPrice } from '../../../util/Format.util';
/**
 * @param {String} cmsData - Data from CMS
 * @param {String} offers - Available offers returned from OCAT
 * @param {Function} onPortingChange - function to be called when user toggles porting option
 * @param {state} loading - loading state of offersData
 * @param {Function} onSimoToggle - function to be called when user toggles SIMO toggle
 * @param {Function} onOfferSelect - function to be called when user select an offer
 * @param {Function} onOfferUnSelect - function to be called when user unselects an offer
 * @param {state} selectedBundle - state of the selected offer
 * @param {String} [simOnly=false] - state of SIMO toggle, defaults to false
 * @returns
 */
const MobileOfferContainer = ({
  billpaySkeleton,
  cmsData,
  offers,
  discounts,
  onPortingChange,
  loading,
  onSimoToggle,
  onOfferSelect,
  onOfferUnSelect,
  selectedBundle,
  simOnly = false,
  // fadeEffect = false,
  // setFadeEffect,
  showLoader,
  existingCustomerCheckValue,
  getSIMOnly,
  hidePortAccordian,
}) => {
  const theme = useTheme();
  // const [state, dispatch] = useReducer(mobileOfferReducer, initialState);
  const [state, setState] = useState({ simOnly });
  const [discountedOffers, setDiscountedOffers] = useState([]);

  // This method is to hide the selected tariff for price Changing Update
  // const RemoveTariff = (Offers, tariff) => Offers?.filter(offer => offer?.code !== tariff);
  const RemoveTariff = (Offers, tariff) => Offers?.filter(offer => !tariff.includes(offer.code));
  useEffect(() => {
    if (simOnly) {
      offers.map(offer => formatAfterPrice(offer, simOnly));
    }
    // check if broadband is in cart or not, and reducing price
    if (discounts?.length > 0 && offers.length > 0) {
      let tempOffers = [...offers];
      // Hiding tariffs with Medium category for CHANGE OFFER-https://confluence.steelhome.internal/display/ZWM/CR+%7C+Change+offer+mobile+pricing+change
      if (simOnly) {
        if (getCookie('cart_Type') === 'CHANGE_OFFER') {
          tempOffers = RemoveTariff(
            tempOffers,
            offers.filter(offer => offer.category === 'MEDIUM').map(offer => offer?.code)
          );
        }
        // Hiding tariffs with HIGH category for CROSS SELL-https://confluence.steelhome.internal/display/ZWM/CR+%7C+Cross+sell+mobile+pricing
        else if (getCookie('cart_Type') === 'CROSS_SELL') {
          tempOffers = RemoveTariff(
            tempOffers,
            offers.filter(offer => offer.category === 'MEDIUM').map(offer => offer?.code)
          );
        } else {
          // Hiding tariffs with MEDIUM category for ACQ-https://confluence.steelhome.internal/display/ZWM/CR+%7C+New+ACQ+mobile+pricing
          tempOffers = RemoveTariff(
            tempOffers,
            offers.filter(offer => offer.category === 'MEDIUM').map(offer => offer?.code)
          );
        }
      }
      // If the user has broadband in their cart, apply the combi discount.
      const offerDiscount = discounts?.length > 0 ? discounts[0].value / 100 : 0;
      const formatAfterPriceValue = afterPrice => {
        let newAfterPrice = '';
        const pricePattern = /([\d.]+)/;
        const match = afterPrice.match(pricePattern);
        if (match) {
          newAfterPrice = afterPrice.replace(
            pricePattern,
            (parseFloat(match[1]) - offerDiscount).toFixed(2)
          );
        } else newAfterPrice = afterPrice;
        return newAfterPrice;
      };
      tempOffers = tempOffers.map(item => ({
        ...item,
        price: (item.price - offerDiscount).toFixed(2),
        afterPrice: formatAfterPriceValue(item.afterPrice),
      }));
      setDiscountedOffers(tempOffers);
    } else {
      let tempOffers = [...offers];
      if (simOnly) {
        // Hiding tariffs with HIGH category for CHANGE OFFER.
        if (getCookie('cart_Type') === 'CHANGE_OFFER') {
          tempOffers = RemoveTariff(
            tempOffers,
            offers.filter(offer => offer.category === 'HIGH').map(offer => offer?.code)
          );
        }
        // Hiding tariffs with MEDIUM category for CROSS SELL.
        else if (getCookie('cart_Type') === 'CROSS_SELL') {
          tempOffers = RemoveTariff(
            tempOffers,
            offers.filter(offer => offer.category === 'HIGH').map(offer => offer?.code)
          );
        } else {
          // Hiding tariffs with HIGH category for ACQ.
          tempOffers = RemoveTariff(
            tempOffers,
            offers.filter(offer => offer.category === 'HIGH').map(offer => offer?.code)
          );
        }
      }
      setDiscountedOffers(tempOffers);
    }
  }, [offers]);

  return (
    <MobileOfferContext.Provider value={{ state, setState }}>
      {/* <KeepMyNumberToggle onPortingChange={onPortingChange} /> */}
      <Container sx={styles(theme).mainContainer}>
        {!hidePortAccordian && (
          <KeepMyNumberToggle
            onPortingChange={onPortingChange}
            // fadeEffect={fadeEffect}
            // setFadeEffect={setFadeEffect}
            existingCustomerCheckValue={existingCustomerCheckValue}
            simOnly={simOnly}
          />
        )}
        <Grid
          container
          sx={
            // fadeEffect
            //   ? {
            //       ...styles(theme).containerMobileOffer,
            //       ...{ pointerEvents: 'none', filter: 'blur(4.5px)' },
            //     }
            //   :
            styles(theme).containerMobileOffer
          }
        >
          <Grid item xs={12}>
            <EirInformation
              title={
                simOnly || getLocalStorage('GET_SIMONLY')
                  ? cmsData?.attributes?.EirInformation_SIMO?.title
                  : cmsData?.attributes?.EirInformation_BillPay?.title
              }
              description={
                simOnly || getLocalStorage('GET_SIMONLY')
                  ? cmsData?.attributes?.EirInformation_SIMO?.description
                  : cmsData?.attributes?.EirInformation_BillPay?.description
              }
              textAlign={
                simOnly || getLocalStorage('GET_SIMONLY')
                  ? cmsData?.attributes?.EirInformation_SIMO?.textAlign
                  : cmsData?.attributes?.EirInformation_BillPay?.textAlign
              }
              useH1={cmsData?.attributes?.EirInformation?.useH1}
            />
          </Grid>
          {/* TODO - MobileOfferToggle is disabled for 1st release */}
          {!getSIMOnly && <MobileOfferToggle onSimoToggle={onSimoToggle} simOnly={simOnly} />}

          {/* mobile offers */}
          <Grid item xs={12}>
            <EirOfferCardContainer
              offers={discountedOffers}
              loading={loading}
              onOfferSelect={onOfferSelect}
              onOfferUnSelect={onOfferUnSelect}
              selectedBundle={selectedBundle}
              showLoader={showLoader}
              simOnly={simOnly}
              billpaySkeleton={billpaySkeleton}
              cmsData={cmsData?.attributes}
              // fadeEffect={fadeEffect}
            />
          </Grid>
        </Grid>
        {/* <MobileSecondaryBannerCurve cmsData={cmsData} /> */}
        {!selectedBundle && (
          <Grid item xs={12} md={12} sx={{ margin: '2.5rem auto 3.75rem' }}>
            <MobileContentCarousel contentCarousel={cmsData?.attributes?.ContentTiles} />
          </Grid>
        )}
      </Container>
    </MobileOfferContext.Provider>
  );
};

export default MobileOfferContainer;
